/**
 * Тур по странице дашборда.
 * Знакомит пользователя с виджетами и настройкой панели.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'dashboard-page',
  name: 'help.tours.dashboard.name',
  description: 'help.tours.dashboard.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Приветствие - блок дашборда
    {
      element: '.dashboard-hero',
      titleKey: 'help.tours.dashboard.welcome.title',
      descriptionKey: 'help.tours.dashboard.welcome.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 2: Блок состояния системы
    {
      element: '.health-status',
      titleKey: 'help.tours.dashboard.healthStatus.title',
      descriptionKey: 'help.tours.dashboard.healthStatus.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 3: Кнопка режима редактирования
    {
      element: '.hero-actions .hero-btn:first-child',
      titleKey: 'help.tours.dashboard.editMode.title',
      descriptionKey: 'help.tours.dashboard.editMode.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 4: Кнопка добавления виджета
    {
      element: '.hero-actions .hero-btn:last-child',
      titleKey: 'help.tours.dashboard.addWidget.title',
      descriptionKey: 'help.tours.dashboard.addWidget.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 5: Сетка виджетов
    {
      element: '.widget-board__grid',
      titleKey: 'help.tours.dashboard.widgetBoard.title',
      descriptionKey: 'help.tours.dashboard.widgetBoard.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 6: Карточка виджета (если есть)
    {
      element: '.widget-tile',
      titleKey: 'help.tours.dashboard.widgetTile.title',
      descriptionKey: 'help.tours.dashboard.widgetTile.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 7: Действия с виджетом
    {
      element: '.widget-tile__actions',
      titleKey: 'help.tours.dashboard.widgetActions.title',
      descriptionKey: 'help.tours.dashboard.widgetActions.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 8: Перетаскивание виджетов
    {
      element: '.widget-tile__drag',
      titleKey: 'help.tours.dashboard.dragDrop.title',
      descriptionKey: 'help.tours.dashboard.dragDrop.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 9: Типы виджетов
    {
      element: '.hero-actions',
      titleKey: 'help.tours.dashboard.widgetTypes.title',
      descriptionKey: 'help.tours.dashboard.widgetTypes.description',
      side: 'bottom',
      align: 'end',
    },
  ],
}
